module.exports = __webpack_public_path__ + "img/knee.43749228.png";